<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                

                <v-btn
                    dark
                    text
                    @click="onClickOk"
                >
                    Ok
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <m-code-block
                :click_anywhere_to_copy="false"
                v-html="code_html"
            >
            </m-code-block>

            

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            is_valid: true,

            title: '',
            code_html: '',
            original_dialog_guard: null,
        }
    },

    created () {
        this.$event_bus.$on('copy_code_dialog', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('copy_code_dialog',this.showDialog);
    },

    methods: {

        showDialog(params)
        {
            this.title = params.title == null ? 'Technical Details' : params.title;
            
            if ( params.object != null )
            {
                params.code = JSON.stringify(params.object, null, 2);
            }

            if ( params.code != null )
            {
                params.code_html = this.$rc.escapeHTML(params.code, false);
            }

            this.code_html = params.code_html;

            
            this.dialog = true;

            this.original_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.original_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = this.original_dialog_guard;
                return;
            }
        
            // data is valid, so save 
            this.closeDialog();
            next(false);
        },

        onClickOk()
        {
            this.closeDialog();
        },
    },
}
</script>

<style lang="scss" scoped>
</style>